// Keep the closed Rebuy cart out of the tab order by mirroring its aria-hidden state to inert
(function () {
  function syncInert(cart) {
    cart.inert = cart.getAttribute('aria-hidden') === 'true';
  }

  function watchCart(cart) {
    syncInert(cart);
    new MutationObserver(function () {
      syncInert(cart);
    }).observe(cart, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  var cart = document.getElementById('rebuy-cart');
  if (cart) {
    watchCart(cart);
    return;
  }

  var bodyObserver = new MutationObserver(function () {
    var cart = document.getElementById('rebuy-cart');
    if (cart) {
      bodyObserver.disconnect();
      watchCart(cart);
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
